import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    limit: 0,
    list: []
};

export const additionalDriverSlice = createSlice({
    name: 'additionalDriver',
    initialState,
    reducers: {
        resetAD: () => initialState,
        setLimit: ( state, { payload } ) => {
            state.limit = payload;
        },
        addAdditionalDriver: ( state, { payload } ) => {
            state.list.push({
                ...payload
            });
        },
        editAdditionalDriver: ( state, { payload } ) => {
            const adList = [...state.list];
            adList[payload.id] = {
                ...adList[payload.id],
                ...payload.info
            };
            state.list = adList;
        },
        removeAdditionalDriver: ( state, { payload } ) => {
            state.list = state.list.filter((_, id) => id != payload);
        },
        setAdditionalDriverSignature: ( state, { payload } ) => {
            const adList = [...state.list];
            adList[payload.id] = {
                ...adList[payload.id],
                signature: {
                    renterSignaturePoints: payload.renterSignaturePoints,
                    svgDescription: payload.svgDescription
                }
            };
            state.list = adList;
        }
    }
});


// Action creators are generated for each case reducer function
export const { resetAD, setLimit, addAdditionalDriver, removeAdditionalDriver, editAdditionalDriver, setAdditionalDriverSignature } = additionalDriverSlice.actions;
